import React from 'react';
import PropTypes from 'prop-types';
import Paper from '@mui/material/Paper';

function FormSectionCard({ children, sx = {}, elevation = 0 }) {
	return (
		<Paper
			elevation={elevation}
			sx={{
				border: '1px solid',
				borderColor: 'divider',
				borderRadius: 2,
				p: { xs: 2, sm: 4 },
				mb: 6,
				...sx,
			}}
		>
			{children}
		</Paper>
	);
}

FormSectionCard.propTypes = {
	children: PropTypes.node.isRequired,
	sx: PropTypes.object,
	elevation: PropTypes.number,
};

export default React.memo(FormSectionCard);
